var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesigner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 660,
    height: 357,
    viewBox: "0 0 660 357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5037",
    "data-name": "Rectangle 5037",
    width: 660,
    height: 357,
    transform: "translate(2168 723)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.043,
    y1: 0.171,
    x2: 1.136,
    y2: 0.586,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4cb8b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099d6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52865",
    "data-name": "Path 52865",
    d: "M134.055,61.63h-.068c-19.934,2.8-42.765,9.319-60.636,23.761C32.589,118.306,51.721,260.873,51.721,260.873H244.739l-7.821-58.637c34.179,3.327,56.476-1.664,56.476-1.664s-11.646-93.615-37.006-116.909c-17.536-16.106-47.154-20.931-63.763-22.4-7.388-.666-12.214-.632-12.214-.632a166.949,166.949,0,0,0-18.448-.893,203.913,203.913,0,0,0-27.908,1.888",
    transform: "translate(-47.236 -59.742)",
    fill: "#f45642"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52871",
    "data-name": "Path 52871",
    d: "M83.608,32.2C68.631,45.928,46.586,38.794,46.586,48.5S60.313,61.8,60.313,61.8s-18.93-1.314-19.135,7S54.7,91.685,73.208,91.271c0,0,4.159,27.245,30.784,26.413l40.352-13.933,26.828-14.144,3.33-9.985s1.664-28.491-5.617-37.439-15.059-5.614-15.059-5.614.083-13.727-17.6-17.677a62.9,62.9,0,0,0-13.709-1.519A57.019,57.019,0,0,0,83.608,32.2",
    transform: "translate(-41.175 -17.372)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.933,
    y1: 3.274,
    x2: -0.911,
    y2: 3.274,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f2323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e3434"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3505",
    "data-name": "Rectangle 3505",
    width: 126.88,
    height: 100.569,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3508",
    "data-name": "Rectangle 3508",
    width: 25.032,
    height: 21.085,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_106",
    "data-name": "Mask Group 106",
    transform: "translate(-2168 -723)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52274",
    "data-name": "Path 52274",
    d: "M0,180.8V489.891a144.67,144.67,0,0,0,144.671,144.67H514.829A144.671,144.671,0,0,0,659.5,489.891V144.683C659.5,59.232,585.825-7.6,500.778.7L130.619,36.815A144.67,144.67,0,0,0,0,180.8",
    transform: "translate(2168 751)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27129",
    "data-name": "Group 27129",
    transform: "translate(6010.885 -5807.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52859",
    "data-name": "Path 52859",
    d: "M160.053,202.4s8.874-10.817,4.439-21.907c-2.781-6.952-7.49-6.658-17.751-19.135s-19.135-43.541,13.313-38.55,41.6.556,35.775-8.042S170.293,93.413,177.93,76.5s37.034-11.093,65.6-8.6,19.135-9.982,36.607-1.664,17.469,56.022-22.742,52.971-47.7-.915-46.037,13.825,8.6,39.975-17.472,30.407-18.918,2.845-14.141,13.1c6.1,13.1-8.874,25.861-8.874,25.861Z",
    transform: "translate(-3540.269 6633.816)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52860",
    "data-name": "Path 52860",
    d: "M161.149,76.571c-8.469-1.694-17.472-15.532-24.682-3.327-5.811,9.835,11.925,24.4,25.514,18.58,10.759-4.61,10.261-13.033-.832-15.252",
    transform: "translate(-3544.416 6644.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52861",
    "data-name": "Path 52861",
    d: "M156.392,151.086v-6.655a19.62,19.62,0,0,0,18.764-14.117l1.123-3.88A7.785,7.785,0,0,0,168.8,116.5h-5.2v-6.658h5.2a14.44,14.44,0,0,1,13.871,18.442l-1.123,3.88a26.307,26.307,0,0,1-25.158,18.924",
    transform: "translate(-3500.833 6730.061)",
    fill: "#70b2dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52862",
    "data-name": "Path 52862",
    d: "M199.381,113.256l-.964,6.689-5.028,34.612a10.99,10.99,0,0,1-10.848,9.417H157.749a10.939,10.939,0,0,1-10.848-9.451l-4.859-34.578-.933-6.722a5.832,5.832,0,0,1,5.792-6.655h46.688a5.858,5.858,0,0,1,5.792,6.689",
    transform: "translate(-3532.584 6723.285)",
    fill: "#abdaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52863",
    "data-name": "Path 52863",
    d: "M199.381,113.256l-.964,6.689H142.042l-.933-6.722a5.832,5.832,0,0,1,5.792-6.655h46.688a5.858,5.858,0,0,1,5.792,6.689",
    transform: "translate(-3532.584 6723.285)",
    fill: "#70b2dd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27130",
    "data-name": "Group 27130",
    transform: "translate(6034.5 -5807.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52864",
    "data-name": "Path 52864",
    d: "M165.494,178.415s7.849-5.946,4.991-32.862-4.991-45.966-4.991-45.966l-58.861,6.446,6.655,53.87Z",
    transform: "translate(-3603.811 6708.837)",
    fill: "#f29c8b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27120",
    "data-name": "Group 27120",
    transform: "translate(-3679.5 6686.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27119",
    "data-name": "Group 27119",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3502",
    "data-name": "Rectangle 3502",
    width: 274.869,
    height: 219.737,
    transform: "matrix(0.997, -0.073, 0.073, 0.997, -29.374, 1.084)",
    fill: "#f45642"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52866",
    "data-name": "Path 52866",
    d: "M229.774,155.239l-8.81-1.246L193.507,82.442s.952,81.033-24.621,105.131-89.913,12.453-89.913,12.453l-9-117.585-19.289,60.2,12.757,71.253H237.6Z",
    transform: "translate(-3719.597 6673.357)",
    fill: "#dd412d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52867",
    "data-name": "Path 52867",
    d: "M143.123,61.266c-1.731,16.173-6.489,39.735-19.835,49.419-21.232,15.375-40.567,8.951-48.885-6.854s1.664-38.67,4.359-40.567l5.725-1.633h.068a198.029,198.029,0,0,1,46.356-1s4.825-.034,12.214.632",
    transform: "translate(-3677.233 6626.377)",
    fill: "#dd412d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52868",
    "data-name": "Path 52868",
    d: "M86.758,187.249H58.743a28.429,28.429,0,0,1-27.856-34.1L42.664,95.317Z",
    transform: "translate(-3761.772 6700.003)",
    fill: "#f29c8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52869",
    "data-name": "Path 52869",
    d: "M77.3,109.392s4.386-9.46,0-13.411A15.1,15.1,0,0,0,67.5,92.236s-2.7-9.359-19.55-7.7S29.493,102,38.932,109.493Z",
    transform: "translate(-3755.83 6677.291)",
    fill: "#feb19e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52870",
    "data-name": "Path 52870",
    d: "M62.329,124.747l-18.8-50A4.315,4.315,0,1,0,35.5,77.915L55.466,126.2Z",
    transform: "translate(-3751.693 6651.646)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27124",
    "data-name": "Group 27124",
    transform: "translate(-3698.102 6556.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27123",
    "data-name": "Group 27123",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3504",
    "data-name": "Rectangle 3504",
    width: 135.198,
    height: 101.144,
    transform: "translate(-0.206 0)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52872",
    "data-name": "Path 52872",
    d: "M131.951,92.184s-5.973,53.189-34.409,49.653C81.779,139.879,80.766,126,82.132,116.943a43.842,43.842,0,0,1,2.661-10.05l-14.141-19.7,39.935-42.7c6.256,20.167,13.11,37.405,21.364,47.688",
    transform: "translate(-3678.274 6594.827)",
    fill: "#feb19e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52873",
    "data-name": "Path 52873",
    d: "M82.132,116.944a43.842,43.842,0,0,1,2.661-10.05l-14.141-19.7L110.587,44.5c15.575,55.675-13.979,69.187-28.455,72.447",
    transform: "translate(-3678.274 6594.829)",
    fill: "#341a1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52874",
    "data-name": "Path 52874",
    d: "M55.744,64.017s28.746,63.6,58.794,61.289c25.235-1.943,33.139-43.4,26.9-54.635,0,0,11.231,1.041,8.736-12.063s-14.768-26.208-17.054,0c0,0-14.7,4.853-19.412-26.76,0,0-14.421,23.571-25.238,26.346S80.7,50.152,80.7,50.152,74.048,60.689,55.744,64.017",
    transform: "translate(-3709.127 6568.652)",
    fill: "#feb19e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52875",
    "data-name": "Path 52875",
    d: "M180.794,193.073H74.036a8.635,8.635,0,0,1-8.021-5.458l-3.459-8.785L33.27,104.284A8.615,8.615,0,0,1,41.29,92.5H146.818a8.665,8.665,0,0,1,7.987,5.359l33.977,83.332a8.614,8.614,0,0,1-7.987,11.879",
    transform: "translate(-3756.902 6694.179)",
    fill: "#1b3151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52876",
    "data-name": "Path 52876",
    d: "M173.274,193.073H74.036a8.635,8.635,0,0,1-8.021-5.458l-3.459-8.785L33.27,104.284A8.615,8.615,0,0,1,41.29,92.5H139.3a8.134,8.134,0,0,1,2.529.4,8.6,8.6,0,0,1,5.458,4.96l33.977,83.332a8.627,8.627,0,0,1-7.987,11.879",
    transform: "translate(-3756.902 6694.179)",
    fill: "#23406d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52877",
    "data-name": "Path 52877",
    d: "M69.669,113.861c1.833,6.415-.086,12.588-4.282,13.788S56.3,124.616,54.471,118.2s.086-12.588,4.282-13.785,9.083,3.033,10.915,9.448",
    transform: "translate(-3713.198 6718.407)",
    fill: "#4e79b7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27127",
    "data-name": "Group 27127",
    transform: "translate(-3694.348 6786.684)",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27126",
    "data-name": "Group 27126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27125",
    "data-name": "Group 27125",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52878",
    "data-name": "Path 52878",
    d: "M160.637,193.073H53.879a8.635,8.635,0,0,1-8.021-5.458L42.4,178.831c52.713-5.491,72.647-59.57,79.268-85.928.034-.132.068-.264.1-.4h4.893a8.665,8.665,0,0,1,7.987,5.359l33.977,83.332a8.614,8.614,0,0,1-7.987,11.879",
    transform: "translate(-42.397 -92.504)",
    fill: "#1b3151"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52879",
    "data-name": "Path 52879",
    d: "M266.565,187.249s-12.063-46.175-132.7-69.47c0,0-9.153-21.217-28.289-22.463l2.913,13.309s-21.217,4.368-40.975,1.872-5.409,17.681,7.9,27.663,16.014,16.226,36.4,11.858,25.167-5.2,25.167-5.2,26,27.454,54.7,42.43Z",
    transform: "translate(-3704.881 6700.003)",
    fill: "#feb19e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27131",
    "data-name": "Group 27131",
    transform: "matrix(0.951, -0.309, 0.309, 0.951, 2392.76, 824.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26071",
    "data-name": "Group 26071",
    transform: "translate(33.046 16.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26070",
    "data-name": "Group 26070",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26069",
    "data-name": "Group 26069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26068",
    "data-name": "Group 26068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26067",
    "data-name": "Group 26067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26066",
    "data-name": "Group 26066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26065",
    "data-name": "Group 26065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26064",
    "data-name": "Group 26064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52128",
    "data-name": "Path 52128",
    d: "M.116,5.319C.558,8,2.136,9.969,3.641,9.722S6.007,7.1,5.565,4.424,3.543-.226,2.039.021-.326,2.64.116,5.319Z",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26079",
    "data-name": "Group 26079",
    transform: "translate(6.438 20.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26078",
    "data-name": "Group 26078",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26077",
    "data-name": "Group 26077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26076",
    "data-name": "Group 26076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26075",
    "data-name": "Group 26075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26074",
    "data-name": "Group 26074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26073",
    "data-name": "Group 26073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26072",
    "data-name": "Group 26072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52129",
    "data-name": "Path 52129",
    d: "M.116,5.319C.558,8,2.138,9.969,3.641,9.722S6.006,7.1,5.564,4.424,3.545-.226,2.039.021-.326,2.64.116,5.319Z",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26087",
    "data-name": "Group 26087",
    transform: "translate(30.935 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26086",
    "data-name": "Group 26086",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26085",
    "data-name": "Group 26085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26084",
    "data-name": "Group 26084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26083",
    "data-name": "Group 26083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26082",
    "data-name": "Group 26082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26081",
    "data-name": "Group 26081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26080",
    "data-name": "Group 26080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52130",
    "data-name": "Path 52130",
    d: "M15.594,6.72C14.51,3.993,11.27-.932,2.125.154A2.412,2.412,0,0,0,.014,2.295h0A2.4,2.4,0,0,0,2.356,4.952a10.8,10.8,0,0,1,8.833,4.356,2.408,2.408,0,0,0,3.51.341l.245-.213A2.409,2.409,0,0,0,15.594,6.72Z",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26095",
    "data-name": "Group 26095",
    transform: "translate(0 3.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26094",
    "data-name": "Group 26094",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26093",
    "data-name": "Group 26093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26092",
    "data-name": "Group 26092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26091",
    "data-name": "Group 26091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26090",
    "data-name": "Group 26090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26089",
    "data-name": "Group 26089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26088",
    "data-name": "Group 26088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52131",
    "data-name": "Path 52131",
    d: "M0,10.574C.153,7.645,1.641,1.943,10.653.051A2.417,2.417,0,0,1,13.34,1.4h0A2.394,2.394,0,0,1,11.975,4.67a10.772,10.772,0,0,0-6.966,6.95A2.406,2.406,0,0,1,1.792,13.06l-.3-.123A2.416,2.416,0,0,1,0,10.574Z",
    fill: "#341a1b"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27132",
    "data-name": "Group 27132",
    transform: "matrix(0.951, -0.309, 0.309, 0.951, 2414.76, 838.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26143",
    "data-name": "Group 26143",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26142",
    "data-name": "Group 26142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26141",
    "data-name": "Group 26141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26140",
    "data-name": "Group 26140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26139",
    "data-name": "Group 26139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26138",
    "data-name": "Group 26138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26137",
    "data-name": "Group 26137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52137",
    "data-name": "Path 52137",
    d: "M9.84,25.36C3.283,26.435.318,22.237.2,22.057a1.112,1.112,0,0,1-.148-.949C3.018,11.142,6.007.909,6.036.806a1.121,1.121,0,0,1,2.154.624c-.029.1-2.908,9.955-5.823,19.743C3.15,22,5.4,23.823,9.476,23.154A1.118,1.118,0,1,1,9.84,25.36Z",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52884",
    "data-name": "Path 52884",
    d: "M-3554.57,6318.459l6.7,2.06,2.167-5.539,2.94,1.188-2.186,5.857,13.2,4.869-1.44,3.722-12.515-4.89-2.167,4.89-4.03-1.811,2.2-4.475-6.3-2.306Z",
    transform: "translate(6036.5 -5293)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27146",
    "data-name": "Group 27146",
    transform: "translate(2475.303 964.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27144",
    "data-name": "Group 27144",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52906",
    "data-name": "Path 52906",
    d: "M21.584,9.723a19.5,19.5,0,0,0-.275-2.429,22.993,22.993,0,0,0-.648-2.7,5.866,5.866,0,0,0-1.213-2.246A5.378,5.378,0,0,0,17.567,1,9.385,9.385,0,0,0,15.7.459,17.8,17.8,0,0,0,13.617.14C12.94.081,12.261.026,11.582.01,10.8-.008,10.016,0,9.234.028a18.669,18.669,0,0,0-2.3.24A18.9,18.9,0,0,0,4.9.7,5.515,5.515,0,0,0,2.082,2.418,5.813,5.813,0,0,0,.929,4.624,25.08,25.08,0,0,0,.245,7.558,16.489,16.489,0,0,0,.037,9.476c-.009.2-.025.409-.037.614v1.052c.006.041.013.083.017.124.051.587.083,1.176.156,1.76A18.742,18.742,0,0,0,.666,15.5a12.388,12.388,0,0,0,.543,1.725,5.247,5.247,0,0,0,2.579,2.711,8.33,8.33,0,0,0,2.069.672c.839.169,1.689.26,2.539.347a22.606,22.606,0,0,0,3.015.119c.474-.015.947-.053,1.42-.094.493-.043.987-.091,1.478-.158a14.371,14.371,0,0,0,2.873-.615,5.3,5.3,0,0,0,2.545-1.815,5.836,5.836,0,0,0,.853-1.7,18.384,18.384,0,0,0,.744-2.937c.1-.623.165-1.251.226-1.879a14.764,14.764,0,0,0,.034-2.156",
    transform: "translate(0 -0.001)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52907",
    "data-name": "Path 52907",
    d: "M221.623,22.481h-.215V21.388h-.47V21.2h1.155v.188h-.47Z",
    transform: "translate(-198.925 -19.088)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52908",
    "data-name": "Path 52908",
    d: "M237.252,22.481l-.35-.677c-.041-.115-.074-.215-.1-.312.007.113.011.235.011.33v.659h-.2V21.2h.264l.375.738c.047.131.054.147.09.267.045-.136.063-.185.09-.262l.373-.736h.265v1.274h-.2v-.659c0-.1,0-.212.011-.33-.036.122-.063.208-.111.33l-.341.659Z",
    transform: "translate(-213.034 -19.088)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52909",
    "data-name": "Path 52909",
    d: "M137.013,44.24h2.2a.06.06,0,0,1,.06.06V56.449a.06.06,0,0,1-.06.06h-2.2a.06.06,0,0,1-.06-.06V44.3a.061.061,0,0,1,.06-.06",
    transform: "translate(-123.308 -39.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52910",
    "data-name": "Path 52910",
    d: "M54.79,44.24h2.2a.06.06,0,0,1,.06.06V56.449a.06.06,0,0,1-.06.06h-2.2a.06.06,0,0,1-.06-.06V44.3a.061.061,0,0,1,.06-.06",
    transform: "translate(-49.277 -39.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52911",
    "data-name": "Path 52911",
    d: "M61.054,85.481a8.094,8.094,0,0,0-3.994,1.766,7.229,7.229,0,0,0-2.327,5.7.062.062,0,0,0,.061.062h2.2a.06.06,0,0,0,.06-.06,5.031,5.031,0,0,1,1.521-3.941,5.522,5.522,0,0,1,2.478-1.163Z",
    transform: "translate(-49.28 -76.964)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesigner);
export default __webpack_public_path__ + "static/media/Designer.3093609ad46c9f5b1a63f27e8358f153.svg";
export { ForwardRef as ReactComponent };